import { type EstimationType } from '../lib/Estimate';
import ItemFilter from './ItemFilter';

export type EstimateTypeFilterValue = EstimationType | 'count' | 'time';

export default class EstimateTypeFilter extends ItemFilter<EstimateTypeFilterValue> {}
